import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { Link } from "react-router-dom";
import { IoCheckmarkCircleOutline } from "react-icons/io5";

const Mijscprograms = () => {

  return (
    <section className='w-full bg-cover h-fit pb-5'>
      <Helmet>
        <title>MIJSC Programs</title>
        <meta name="description" content="Learn more about MIJSC, our mission, vision, and commitment to excellence." />
      </Helmet>
      <BreadCrumbs />
      <div className='md:max-0 md:px-0 px-4 w-full h-fit md:flex  place-content-center gap-7'>
        <div className='py-5'>
          <Link to='/faculty-development-program' className='cursor-pointer'>
            <div className="rounded-t-xl md:w-[35rem] relative  h-[180px] bg-cover bg-center transition-all duration-700" style={{ backgroundPosition: 'top', backgroundImage: `url(${process.env.PUBLIC_URL}/assets/lmp-faculty-development-program.jpg)` }}></div>
            <div className='shadow-xl md:w-[35rem] h-fit pb-10 rounded-b-lg px-4 text-left'>
              <h3 className='text-2xl font-bold mt-5'>LMP Faculty Development Program</h3>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-bold text-sm  text-gray-600'> Facilitator: MIJSC@IIMB.</p>
              </div>
              <div className="flex gap-3 items-center">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-semibold text-sm my-2 text-gray-600'> Timeline: 6 months.</p>
              </div>
              <div className="flex gap-3 items-center">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-semibold text-sm my-2 text-gray-600'>Key Benefits: Faculty developed as Lean experts.</p>
              </div>

            </div>
          </Link>
        </div>
        <div className='py-5'>
          <Link to='/skill-development' className='cursor-pointer'>
            <div className="rounded-t-xl md:w-[35rem] relative  h-[180px] bg-cover bg-center transition-all duration-700" style={{ backgroundPosition: 'top', backgroundImage: `url(${process.env.PUBLIC_URL}/assets/lmp-student-skill-development-program.jpg)` }}></div>
            <div className='shadow-xl md:w-[35rem] h-fit pb-10 rounded-b-lg px-4 text-left'>
              <h3 className='text-2xl font-bold mt-5'>LMP Student Skill Development Program</h3>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-bold text-sm  text-gray-600'> Facilitator: Engineering College. </p>
              </div>
              <div className="flex gap-3 items-center">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-semibold text-sm my-2 text-gray-600'> Timeline: Recommended in 5th & 6th Sem. </p>
              </div>
              <div className="flex gap-3 items-center">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-semibold text-sm my-2 text-gray-600'> Key Benefits: Students become industry ready</p>
              </div>
            </div>
          </Link>
        </div>
      </div>

      <div className='md:max-0 md:px-0 px-4 w-full h-fit md:flex  place-content-center gap-7'>
        <div className='py-5'>
          <Link to='/consultancy-program' className='cursor-pointer'>
            <div className="rounded-t-xl md:w-[35rem] relative  h-[180px] bg-cover bg-center transition-all duration-700" style={{ backgroundPosition: 'top', backgroundImage: `url(${process.env.PUBLIC_URL}/assets/lmp-consultancy-program.jpg)` }}></div>
            <div className='shadow-xl md:w-[35rem] h-fit pb-16 rounded-b-lg px-4 text-left'>
              <h3 className='text-2xl font-bold mt-5'>LMP Consultancy Program</h3>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-bold text-sm  text-gray-600'>Facilitator: MIJSC @ IIMB.</p>
              </div>
              <div className="flex gap-3 items-center">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-semibold text-sm my-2 text-gray-600'> Timeline: 6 Months.</p>
              </div>
              <div className="flex gap-3 items-center">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-semibold text-sm my-2 text-gray-600'>Outcome: Faculty Consulting for Industry </p>
              </div>
            </div>
          </Link>
        </div>


        <div className='py-5'>
          <Link to='/jlcc-program' className='cursor-pointer'>
            <div className="rounded-t-xl md:w-[35rem] relative  h-[180px] bg-cover bg-center transition-all duration-700" style={{ backgroundPosition: 'inherit', backgroundImage: `url(${process.env.PUBLIC_URL}/assets/imgs/program-for-students.avif)` }}></div>
            <div className='shadow-xl md:w-[35rem] h-fit pb-5 rounded-b-lg px-4 text-left'>
              <h3 className='text-2xl font-bold mt-5'>JLCC Program for students</h3>
              <div className="flex gap-3 items-center mt-3">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-bold text-sm  text-gray-600'>Facilitator: MIJSC @ IIMB. </p>
              </div>
              <div className="flex gap-3 items-center">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-semibold text-sm my-2 text-gray-600'>Timeline: 1 year each for JLCC 1 & JLCC 2 (Recommended from 3rd to 6th Sem).</p>
              </div>
              <div className="flex gap-3 items-center">
                <IoCheckmarkCircleOutline className="text-xl text-green-600" />
                <p className='font-semibold text-sm my-2 text-gray-600'>Outcome: Students attain proficiency to attend JLPT N5 and N4 level test.</p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section >
  )
}

export default Mijscprograms
